// extracted by mini-css-extract-plugin
module.exports = {"link":"ReportProfile_link__m3DLT"};